export default __webpack_public_path__ + "static/media/644.a75e2289.gif";